"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportWarehouseExcel = exports.ExportExcelType = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _date = require("@/utils/date");
var _index = require("@/utils/index");
var _string = require("@/utils/string");
var Excel = _interopRequireWildcard(require("exceljs"));
var _fileSaver = require("file-saver");
var ExportExcelType;
(function (ExportExcelType) {
  ExportExcelType["RealPublish"] = "REAL_PUBLISH";
  ExportExcelType["RealNoPublish"] = "REAL_NO_PUBLISH";
})(ExportExcelType || (exports.ExportExcelType = ExportExcelType = {}));
var fontBold = {
  font: {
    bold: true
  }
};
var fontBoldRed = {
  font: {
    bold: true,
    color: {
      argb: "FF2600"
    }
  }
};
var fontBoldBlack = {
  font: {
    bold: true,
    color: {
      argb: "000000"
    }
  }
};
var border = {
  top: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  left: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  bottom: {
    style: "thin",
    color: {
      argb: "#000"
    }
  },
  right: {
    style: "thin",
    color: {
      argb: "#000"
    }
  }
};
var row = 0;
var reportWarehouseExcel = exports.reportWarehouseExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var data, type, date, fileName, workbook, worksheet, startTableRow, startTable, dataFilter, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = _ref.data, type = _ref.type, date = _ref.date;
          // config export excel
          fileName = "Report warehouse ".concat(type);
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("Report", {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            },
            views: [{
              state: 'frozen',
              ySplit: 2
            }]
          }); //add table
          startTableRow = 1;
          startTable = worksheet.getCell("A".concat(startTableRow++));
          startTable.style = {
            font: {
              color: {
                argb: "ffff0202"
              }
            }
          };
          dataFilter = [];
          if (type == ExportExcelType.RealPublish) {
            dataFilter = data.filter(function (e) {
              return e.isPublished;
            });
          } else if (type == ExportExcelType.RealNoPublish) {
            dataFilter = data.filter(function (e) {
              return !e.isPublished;
            });
          } else if (type == '') {
            dataFilter = data;
          }
          generateTable(worksheet, dataFilter, startTableRow, date);
          _context.next = 12;
          return workbook.xlsx.writeBuffer();
        case 12:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function reportWarehouseExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var generateTable = function generateTable(worksheet, data, startTableRow, date) {
  //transform data
  var report = [];
  data.forEach(function (e) {
    e.details.forEach(function (detail) {
      if (!detail.quantityStart && !detail.quantityImport && !detail.quantityExportGiveaway && !detail.quantityExportOrder && !detail.quantityEnd) {
        return;
      }
      var temp = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, detail), e), {}, {
        lotQuantity: detail.quantity,
        importDate: detail.importDates.map(function (date) {
          return (0, _date.formatDate)(date);
        }).join(", "),
        rowspan: 0
      });
      report.push(temp);
    });
    // if (isEmpty(e.details)) {
    //   report.push({ ...e, rowspan: 0, lotQuantity: '--', lotNumber: '--' })
    // }
  });
  var count = 0;
  report.forEach(function (element, index) {
    count++;
    if (index < report.length - 1 && element.id != report[index + 1].id) {
      report[index + 1 - count].rowspan = count;
      count = 0;
    }
  });
  if (report.length) {
    report[report.length - count].rowspan = count;
  }
  var startRow = startTableRow;
  var dataExcel = [{
    value: "Product",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "name",
    width: 20,
    mergeRow: true
  }, {
    value: "Lot No",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "lotNumber",
    width: 20
  }, {
    value: "Manufacture date",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "dateOfManufacture",
    format: 'date',
    width: 15
  }, {
    value: "Expired",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "expired",
    format: 'date',
    width: 15
  }, {
    value: "Start",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "quantityStart",
    numFmt: '#,##0',
    width: 12
  }, {
    value: "In stock",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "quantityImport",
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Giveaway",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "quantityExportGiveaway",
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Order",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'quantityExportOrder',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Start Deposited",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'depositStart',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Deposited order consignment",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'deposit',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Deposited giveaway consignment",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'depositGift',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Sold order consignment",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'saleConsign',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Sold giveaway consignment",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'saleConsignGiveaway',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Return order consignment",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'quantityReturnOrder',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Return giveaway consignment",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'quantityReturnGift',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "Remaining consignment",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: 'remainConsign',
    numFmt: '#,##0',
    width: 12
  }, {
    value: "End",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "quantityEnd",
    numFmt: '#,##0',
    width: 12
  },
  // {
  //   value: "Quantity",
  //   style: {
  //     ...fontBold,
  //   },
  //   prop: "lotQuantity",
  //   numFmt: '#,##0',
  //   width: 15,
  // },
  {
    value: "Import date",
    style: (0, _objectSpread2.default)({}, fontBold),
    prop: "importDate",
    width: 30
  }];
  //render title
  var headerRow = worksheet.getRow(1);
  var dateString = '';
  if (date.length == 2) {
    dateString = "- ".concat((0, _date.formatDateFromString)(date[0]), " - ").concat((0, _date.formatDateFromString)(date[1]));
  }
  headerRow.values = ["\u5728\u5EAB\u7BA1\u7406\u8868/ B\u1EA2NG QU\u1EA2N L\xDD T\u1ED2N KHO ".concat(dateString)];
  headerRow.eachCell(function (item) {
    return item.style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fontBold), {}, {
      alignment: {
        horizontal: 'center'
      }
    });
  });
  worksheet.mergeCells(1, 1, 1, dataExcel.length);
  var char = "A";
  dataExcel.forEach(function (element) {
    var style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'ffff01'
        },
        bgColor: {
          argb: 'ffff01'
        }
      },
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    var styleConsignment = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, element.style), {}, {
      border: border,
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FCD5B4'
        },
        bgColor: {
          argb: 'FCD5B4'
        }
      },
      alignment: {
        wrapText: true,
        vertical: 'middle'
      }
    });
    if (char >= 'I' && char <= 'P') {
      worksheet.getCell("".concat(char).concat(startRow)).style = styleConsignment;
    } else {
      worksheet.getCell("".concat(char).concat(startRow)).style = style;
    }
    worksheet.getCell("".concat(char).concat(startRow)).value = element.value;
    worksheet.getRow(startRow).height = 50;
    row = startRow + 1;
    report.forEach(function (order, index) {
      var rowIndex = startRow + index + 1;
      worksheet.getRow(rowIndex).height = 50;
      var style = {
        border: border,
        alignment: {
          wrapText: true,
          vertical: 'middle'
        }
      };
      if (char == 'P') {
        style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fontBoldBlack), {}, {
          border: border,
          alignment: {
            wrapText: true,
            vertical: 'middle'
          }
        });
      }
      if (char == 'Q') {
        style = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fontBoldRed), {}, {
          border: border,
          alignment: {
            wrapText: true,
            vertical: 'middle'
          }
        });
      }
      worksheet.getCell("".concat(char).concat(rowIndex)).style = style;
      element.numFmt && (worksheet.getCell("".concat(char).concat(rowIndex)).numFmt = element.numFmt);
      var value = (0, _index.generateProp)(order, element.prop, element.format);
      if (element.mergeRow && order.rowspan) {
        worksheet.mergeCells("".concat(char).concat(rowIndex, ":").concat(char).concat(rowIndex - 1 + order.rowspan));
      }
      worksheet.getCell("".concat(char).concat(rowIndex)).value = value;
      row = rowIndex;
    });
    char = (0, _string.nextChar)(char);
  });
  worksheet.columns.forEach(function (e, i) {
    if (dataExcel[i]) e.width = dataExcel[i].width;
  });
};